/** Visible defaults follow the tenant business timezone, never the browser/UTC month. */
export function cashBusinessDate(timezone, now = new Date()) {
    try {
        const parts = new Intl.DateTimeFormat('en-CA', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
        const part = (type) => parts.find(row => row.type === type)?.value || '';
        return `${part('year')}-${part('month')}-${part('day')}`;
    }
    catch {
        return '';
    }
}
